import { createI18n } from 'vue-i18n'

const messages = {
  no: {
    // Restaurant info
    restaurantName: 'Dandero Restaurant',
    welcome: 'Velkommen! Vennligst skriv inn bordnummer for å begynne å bestille',
    
    // Table entry
    tableNumber: 'Bordnummer',
    enterTableNumber: 'Skriv inn bordnummer',
    continueToMenu: 'Gå til meny',
    tableNumberError: 'Vennligst skriv inn et bordnummer',
    invalidTableNumber: 'Vennligst skriv inn et gyldig bordnummer (1-99)',
    cantFindTable: 'Finner du ikke bordnummeret? Spør personalet om hjelp.',
    
    // Header
    table: 'Bord',
    
    // Menu categories
    starters: 'Forretter',
    burgers: 'Burgere',
    mains: 'Hovedretter',
    desserts: 'Desserter',
    sodas: 'Brus',
    beers: 'Øl',
    
    // Menu actions
    add: 'Legg til',
    
    // Shopping cart
    yourOrder: 'Din bestilling',
    emptyCart: 'Handlekurven er tom',
    addItemsFromMenu: 'Legg til noen deilige retter fra menyen!',
    subtotal: 'Delsum:',
    tax: 'MVA (25%):',
    total: 'Totalt:',
    proceedToCheckout: 'Gå til bestilling',
    placeOrder: 'Send bestilling',
    checkout: 'Bestilling',
    orderSummary: 'Ordresammendrag',
    orderSentMessage: 'Din bestilling er sendt til kjøkkenet!',
    each: 'stk',
    basePrice: 'Grunnpris',
    cartIsEmptySubtitle: 'Ser ut som du ikke har lagt til noe ennå.',
    browseMenu: 'Se meny',
    reviewOrder: 'Se over bestillingen før du sender den.',
    backToMenu: 'Tilbake til meny',
    orderMore: 'Bestill mer',
    orderPlacedSuccess: 'Bestilling mottatt!',
    orderSentToKitchen: 'Din bestilling for Bord {tableNumber} er sendt til kjøkkenet.',
    orderNumber: 'Bestilling #{orderNumber}',
    ok: 'OK',
    
    // Collaborative mode
    newOrder: 'Ny bestilling',
    joinOrder: 'Bli med på bestilling',
    pinCode: 'PIN-kode',
    enterPinCode: 'Skriv inn PIN-kode',
    yourName: 'Ditt navn',
    enterYourName: 'Skriv inn ditt navn',
    pinRequired: 'PIN-kode er påkrevd',
    nameRequired: 'Navn er påkrevd',
    invalidPin: 'Ugyldig PIN-kode',
    enterAdminName: 'Skriv inn ditt navn som bordadministrator:',
    shareThisTable: 'Del dette bordet',
    shareTableDescription: 'La andre bli med på din bestilling og legge til sine egne retter.',
    allowOthersToJoin: 'La andre bli med',
    orderAloneDescription: 'Eller fortsett å bestille alene uten å dele.',
    
    // Item customization
    size: 'Størrelse',
    cheese: 'Ost',
    sauces: 'Sauser',
    added: 'Tillagt',
    removed: 'Fjernet',
    notes: 'Notater',
    loadingMenu: 'Laster meny...',
    menuLoadError: 'Kunne ikke laste menyen',

    // Customization Options
    smallSalad: 'Liten',
    largeSalad: 'Stor',
    '8pieces': '8 biter',
    '12pieces': '12 biter',
    '16pieces': '16 biter',
    smallGlass: 'Liten',
    mediumGlass: 'Medium',
    largeGlass: 'Stor',
    bottle330ml: 'Flaske (0,33l)',
    pint500ml: 'Pint (0,5l)',
    can440ml: 'Boks (0,44l)',
    
    grilledChicken: 'Grillet kylling',
    bacon: 'Bacon',
    avocado: 'Avokado',
    croutons: 'Krutonger',
    parmesan: 'Parmesan',
    extraBacon: 'Ekstra bacon',
    friedEgg: 'Speilegg',
    extraAvocado: 'Ekstra avokado',
    grilledPeppers: 'Grillet paprika',
    cucumber: 'Agurk',
    triplePatty: 'Trippel burger',
    onionRings: 'Løkringer',
    extraLime: 'Ekstra lime',
    freshMint: 'Fersk mynte',
    ice: 'Isbiter',
    limeWedge: 'Limebåt',
    
    marinara: 'Marinara',
    ranch: 'Ranch',
    garlicAioli: 'Hvitløksaioli',
    buffalo: 'Buffalo',
    bbqSauce: 'BBQ Saus',
    honeyMustard: 'Honning-sennep',
    teriyaki: 'Teriyaki',
    ketchup: 'Ketchup',
    mayo: 'Majones',
    mustard: 'Sennep',
    aioli: 'Aioli',
    chipotleMayo: 'Chipotle majones',
    srirachaAioli: 'Sriracha aioli',
    veganMayo: 'Vegan majones',
    hummus: 'Hummus',
    tahini: 'Tahini',
    
    cheddar: 'Cheddar',
    swiss: 'Sveitserost',
    blueCheese: 'Blåmuggost',
    goatCheese: 'Geitost',
    smokedGouda: 'Røkt Gouda',
    noCheese: 'Ingen ost',
    veganCheese: 'Veganost',
    regularCheese: 'Vanlig ost',
    doubleCheddar: 'Dobbel Cheddar',
    mixedCheese: 'Blandet ost',
    tripleCheese: 'Trippel ost',
    mozzarella: 'Mozzarella',
    
    // Shared cart
    ordering: 'Bestiller',
    changePerson: 'Bytt person',
    whoIsOrdering: 'Hvem bestiller?',
    selectPerson: 'Velg person',
    items: 'elementer',
    enterName: 'Skriv inn navn',
    sharedOrder: 'Delt bestilling',
    orderedBy: 'Bestilt av',
    individualSubtotal: 'Delsum for {name}:',
    pleaseSelectPerson: 'Vennligst velg hvem som bestiller først',
    unknownPerson: 'Ukjent person',
    personAlreadyTaken: 'Denne personen er allerede i bruk av noen andre',
    takenByOther: 'Tatt av annen bruker',
    
    // Collaborative features
    onlyYouOnline: 'Bare du er pålogget',
    peopleOnline: '{count} personer pålogget',
    syncingData: 'Synkroniserer data...',
    dataUpdated: 'Bestillingen ble oppdatert av en annen bruker',
    tableParticipants: 'Deltakere',
    host: 'Vert',
    online: 'Pålogget',
    offline: 'Frakoblet',
    makeHost: 'Gjør til vert',
    
    // Change table functionality
    changeTable: 'Bytt bord',
    changeTableTitle: 'Bytt til et annet bord?',
    changeTableWarning: 'Ved å bytte bord vil følgende skje:',
    changeTableWarning1: 'All nåværende handlekurv blir slettet',
    changeTableWarning2: 'Du blir koblet fra dette bordet',
    changeTableWarning3: 'Du må velge et nytt bordnummer',
    cancel: 'Avbryt',
    
    // Landing View
    startTable: 'Start bord',
    joinTable: 'Bli med på bord',
    groupOrdering: 'Gruppebestilling',
    createSession: 'Opprett sesjon',
    startOrdering: 'Start bestilling',
    joinSession: 'Bli med',
    enterNameHint: 'Du blir vert for denne sesjonen.',
    hostHint: 'Du blir vert for denne sesjonen.',
    
    // Header
    exit: 'Avslutt',
    leaveTableConfirm: 'Er du sikker på at du vil forlate bordet?',
    onlyHostCanCheckout: 'Bare verten kan fullføre bestillingen',
    changeWhoChecksOut: 'Endre hvem som skal fullføre bestillingen',
    
    // Customizer
    addToCart: 'Legg til',
    addExtras: 'Legg til ekstra',
    removeIngredients: 'Fjern ingredienser',
    specialInstructions: 'Spesielle instruksjoner',
    specialInstructionsPlaceholder: 'Allergier eller spesielle ønsker?',
    
    // Payment
    preparingPayment: 'Forbereder betaling...',
    paymentError: 'Betalingsfeil',
    tryAgain: 'Prøv igjen',
    backToCheckout: 'Tilbake til bestilling',
    verifyingPayment: 'Verifiserer betaling...',
    paymentSuccess: 'Betaling fullført!',
    paymentSuccessMessage: 'Takk for din bestilling. Maten er snart på vei!',
    paymentFailed: 'Betaling mislyktes',
    paymentFailedMessage: 'Betalingen kunne ikke gjennomføres. Vennligst prøv igjen.',
    paymentCancelled: 'Betaling avbrutt',
    paymentCancelledMessage: 'Du avbrøt betalingen. Du kan prøve igjen eller endre bestillingen.',
    orderBeingPrepared: 'Bestillingen din forberedes nå. Du vil bli varslet når den er klar!',
    endSession: 'Avslutt sesjon',
    payWithDintero: 'Betal med Dintero',
    proceedToPayment: 'Gå til betaling',
    noPay: 'uten betaling',
    
    // Restaurant identification
    loadingRestaurant: 'Laster restaurant...',
    restaurantNotFound: 'Restaurant ikke funnet',
    restaurantNotFoundHint: 'Denne restauranten finnes ikke eller har ikke aktivert bordbestilling.',
    scanQrHint: 'Skann QR-koden på bordet ditt for å starte bestillingen.',
    tableOrdering: 'Bordbestilling',
    tableFromQr: 'Bord {table} (fra QR-kode)',
    wrongRestaurantPin: 'Denne PIN-koden tilhører en annen restaurant',

    // Age verification
    ageVerificationTitle: 'Aldersbekreftelse',
    ageVerificationQuestion: 'Er du 18 år eller eldre?',
    ageVerificationYes: 'Ja, jeg er 18+',
    ageVerificationNo: 'Nei',
    ageVerificationRejected: 'Alkohol kan kun serveres til gjester som er 18 år eller eldre.',
  }
}

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  globalInjection: true, // Inject $t globally for templates
  locale: 'no', // Norwegian as default
  fallbackLocale: 'no',
  messages
})

export default i18n